var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"search",staticStyle:{"width":"350px"},attrs:{"rounded":"","filled":"","single-line":"","clearable":"","dense":"","hide-details":"","placeholder":"Search","background-color":"white","prepend-inner-icon":"mdi-magnify","search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }